module.exports = __webpack_public_path__ + "img/2.195f1881.jpg";